import React from 'react';
import { MasterLayout } from 'layout';
import { DanhSachDon } from 'modules/theo-doi-giam-sat'

export default class DanhSachDonPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachDon id={this.props.params.id}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-giam-sat/DanhSachDonPage.jsx